(function($) {
  'use strict';

	// Get embedded SVG and convert to inline SVG
	// Uses the class .svg to get target
	$(".explode img").each(function() {
		let img = $(this),
		    imgURL = img.attr('src');

		fetch(imgURL)
      .then(response => response.text())
      .then(data => {
        let svg = $(data);
        if( !svg.attr('viewBox') && svg.attr('height') && svg.attr('width') ) {
          svg.attr('viewBox', '0 0 ' + svg.attr('height') + ' ' + svg.attr('width'));
        }
        img.replaceWith(svg);
      });
	});

})(jQuery);
